



const COUNTRY_SELECTOR = '#geo'

const geoTag = document.querySelector(COUNTRY_SELECTOR)



class Geolocation {
    constructor() {
        console.log('Geolocation constructor()');
    }


    getCountryCode() {
        return geoTag ? geoTag.dataset.gsidCc : 'ww';
    }
    
    getLanguageCode() {
        return geoTag ? geoTag.dataset.cc : 'ww';
    }
    
    getLocale() {
        return this.getCountryCode();
    }
}


export default Geolocation;

